import { useRef, useState } from "react";
import { Play, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export function DemoVideoSection() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    setPlaying(true);
    videoRef.current?.play();
  };

  return (
    <section className="px-6 py-20 bg-[#0B0F19] text-white relative overflow-hidden" data-testid="section-demo-video">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[350px] rounded-full bg-[#4F46E5]/15 blur-[120px] pointer-events-none" />
      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#22D3EE] bg-white/5 border border-white/10 px-3 py-1.5 rounded-full mb-5">
            <Sparkles className="w-3.5 h-3.5" /> See it in action
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-3">Watch demo video</h2>
          <p className="text-white/60 max-w-2xl mx-auto">
            A real walkthrough of every poll, quiz, word cloud and survey chart type — presented live on
            "Youth Clothing Consumer Behavior in India", our full feature-showcase deck.
          </p>
        </div>

        <div
          className="relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_30px_80px_rgba(79,70,229,0.25)]"
          data-testid="demo-video-player-wrapper"
        >
          <video
            ref={videoRef}
            data-testid="demo-video-player"
            className="w-full block bg-black"
            style={{ aspectRatio: "1600/900" }}
            poster="/videos/demo-poster.jpg"
            controls={playing}
            playsInline
            onEnded={() => setPlaying(false)}
          >
            <source src="/videos/demo-walkthrough.mp4" type="video/mp4" />
          </video>

          {!playing && (
            <button
              onClick={handlePlay}
              data-testid="demo-video-play-button"
              aria-label="Play demo video"
              className="absolute inset-0 flex items-center justify-center group bg-black/20 hover:bg-black/10 transition-colors"
            >
              <span
                className="w-20 h-20 rounded-full flex items-center justify-center transition-transform group-hover:scale-110"
                style={{ background: "linear-gradient(135deg,#8B5CF6,#06B6D4)", boxShadow: "0 0 40px rgba(139,92,246,0.6)" }}
              >
                <Play className="w-8 h-8 text-white fill-white ml-1" />
              </span>
            </button>
          )}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/join/440672"
            data-testid="demo-video-try-live-link"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-white bg-white/5 hover:bg-white/10 border border-white/10 px-5 py-2.5 rounded-full transition-colors"
          >
            Try this exact demo live — code 440672 <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
